// extracted by mini-css-extract-plugin
export default {"root":"nvBki3b7mLA1BiYwC1VR","money":"bTivirxSXn1m6SFL5fBV","dev":"VpldTBiwMqbt1FufmQX1"};